// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"4a8b72fe","541":"4a8b72fe","899":"4a8b72fe"}[chunkId] + ".chunk.css";
};